<template>
  <form action="">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
        <o-icon
          clickable
          native-type="button"
          icon="times"
          @click.native="$emit('close')"/>
      </header>
      <section class="modal-card-body">
        <p v-html="message"></p>
      </section>
      <footer class="modal-card-foot">
        <o-button type="button" @click="$emit('close')">{{ cancelText }}</o-button>
        <o-button :variant="variant"
                  @click="confirmModal()">{{ confirmText }}
        </o-button>
      </footer>
    </div>
  </form>
</template>

<script>
export default {
  name: "Confirm",
  props: {
    title: {
      type: String,
      default: 'Confirm'
    },
    message: String,
    confirmText: {
      type: String,
      default: 'OK'
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    variant: {
      type: String,
      default: 'primary'
    },
  },
  methods: {
    confirmModal() {
      this.$emit('onConfirm')
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.modal-card {
  width: 600px;
}
</style>
